import api from "../utils/api";
import { getFetch } from "../utils/request.js";
const userModel = {
  // 登录
  login: async (data = {}) => {
    const success = await getFetch(api.login, data);
    return success;
  },
  // 获取token
  getToken: async (data = {}) => {
    const success = await getFetch(api.getToken, data);
    return success;
  },
  // 注册
  register: async (data = {}) => {
    const success = await getFetch(api.register, data);
    return success;
  },
  // 注销
  logout: async (data = {}) => {
    const success = await getFetch(api.logout, data);
    return success;
  },
  // 发送验证码
  sendCode: async (data = {}) => {
    const success = await getFetch(api.sendCode, data);
    return success;
  },
  // 实名认证
  bindRealName: async (data = {}) => {
    const success = await getFetch(api.bindRealName, data);
    return success;
  },
  // 获取实名认证信息
  getRealName: async (data = {}) => {
    const success = await getFetch(api.getRealName, data);
    return success;
  },
  // 实名认证日志情况上报接口
  reportRealName: async (data = {}) => {
    const success = await getFetch(api.reportRealName, data);
    return success;
  },
  // 生成账号密码
  getAccount: async (data = {}) => {
    const success = await getFetch(api.getAccount, data);
    return success;
  },
  // 微端同步登录
  syncLogin: async (data = {}) => {
    const success = await getFetch(api.syncLogin, data);
    return success;
  },
};

export default userModel;
